import { render, staticRenderFns } from "./dianiSunriseTwo.vue?vue&type=template&id=83d00cda&scoped=true&"
import script from "./dianiSunriseTwo.vue?vue&type=script&lang=js&"
export * from "./dianiSunriseTwo.vue?vue&type=script&lang=js&"
import style0 from "./dianiSunriseTwo.vue?vue&type=style&index=0&id=83d00cda&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d00cda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VIcon,VImg,VRow})
